import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersSkillEvaluationTermEditType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiManagersSkillEvaluationTermEditType> => {
  const response =
    await new ApiClient().get<ApiManagersSkillEvaluationTermEditType>(
      `/api/managers/skill_evaluation_terms/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersSkillEvaluationTermsEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersSkillEvaluationTermEditType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersSkillEvaluationTermsEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
